import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import ProgressIndicator from 'components/progress-indicators/progress-indicator'
import Grid from '@material-ui/core/Grid'

import CoachView from './coach-view'
import ConsumerView from './consumer-view'

import StepDesciptionOfferings from '../step-description-offerings'
import CoachAddStudentModal from 'components/add-student-modal/coach-add-student-modal'
import ConsumerAddStudentModal from 'components/add-student-modal/consumer-add-student-modal'

export default ({ students, currentUrl, previousUrl, isCoach, user }) => {
  const [openAddStudent, setOpenAddStudent] = useState(false)
  const history = useHistory()

  return (
    <>
      <Grid container spacing={2}>
        <ProgressIndicator value={50} />
        <StepDesciptionOfferings
          stepText="Step 2 of 3"
          title="Select a Student"
          description={
            isCoach
              ? 'Select a student to attend this session.'
              : 'Who will be attending this session?'
          }
        />
      </Grid>
      {isCoach ? (
        <>
          <CoachView
            searchableItems={students}
            history={history}
            currentUrl={currentUrl}
            openAddStudent={openAddStudent}
            setOpenAddStudent={setOpenAddStudent}
          />
          <CoachAddStudentModal
            open={openAddStudent}
            setOpen={setOpenAddStudent}
            onAdd={data => {
              const newStudentId = data?.createStudent?.student?.id
              history.push(`${currentUrl}&studentId=${newStudentId}`)
            }}
            dialogTitle="Add New Student"
            btnTitle="Add Student"
          />
        </>
      ) : (
        <>
          <ConsumerView
            students={students}
            history={history}
            currentUrl={currentUrl}
            openAddStudent={openAddStudent}
            setOpenAddStudent={setOpenAddStudent}
            user={user}
          />
          <ConsumerAddStudentModal
            open={openAddStudent}
            setOpen={setOpenAddStudent}
            onAdd={data => {
              const newStudentId = data?.createStudent?.student?.id
              history.push(`${currentUrl}&studentId=${newStudentId}`)
            }}
            dialogTitle="Add New Student"
            btnTitle="Add Student"
          />
        </>
      )}
    </>
  )
}
